/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * TFA API
 * API for TFA
 * OpenAPI spec version: 2.0.0 (api.admin.v1)
 */

/**
 * * `SUNDAY` - Sunday
* `MONDAY` - Monday
* `TUESDAY` - Tuesday
* `WEDNESDAY` - Wednesday
* `THURSDAY` - Thursday
* `FRIDAY` - Friday
* `SATURDAY` - Saturday
 */
export type DayOfWeekEnum = typeof DayOfWeekEnum[keyof typeof DayOfWeekEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DayOfWeekEnum = {
  SUNDAY: 'SUNDAY',
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY',
} as const;
